import React, { FunctionComponent } from 'react'
import { generatePath, Navigate, Route, Routes } from 'react-router'

import { ManagementType } from '../../../../state/configuration'
import { AppPath } from '../../../AppPath'
import { useProduct } from '../../ProductProvider'
import {
  AdditionalProfileAdjustmentRouter,
  PolicyAdjustmentPath,
  PolicyAdjustmentRouter,
} from '../adjustments'
import { ManagementPage } from './ManagementPage'

export const PolicyManagementRouter: FunctionComponent = () => {
  const {
    product: { management },
  } = useProduct()

  const routes = management.map((it) => {
    const path = generatePath(PolicyAdjustmentPath.Section, { sectionId: it.id })

    const element = (() => {
      switch (it.type) {
        case ManagementType.ADDITIONAL_PROFILE:
          return <AdditionalProfileAdjustmentRouter config={it} />
        default:
          return <PolicyAdjustmentRouter config={it} />
      }
    })()

    return <Route key={it.id} path={path + AppPath.WILDCARD} element={element} />
  })

  return (
    <Routes>
      <Route index element={<ManagementPage />} />
      {routes}
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
